/* eslint-disable */

class ProductCardSubscription extends HTMLElement {
  constructor() {
    console.log('ProductCardSubscription constructor')
    super()
    this.variantId = this.getAttribute('variant-id')
    this.productHandle = this.getAttribute('product-handle')
    this.subscriptionPlans = {}
    this.button = null
  }

  connectedCallback() {
    this.button = this.querySelector('button')
    if (!this.button) {
      console.warn('<product-card-subscription> is missing a <button>.')
      return
    }

    this.button.addEventListener('click', () => this.addFirstPlanToCart())
  }

  async addFirstPlanToCart() {
    console.log('Button clicked. Starting fetch for:', this.productHandle)
    try {
      const res = await fetch(`/products/${this.productHandle}`)
      console.log('Fetched PDP HTML for', this.productHandle)
      const text = await res.text()
      const doc = new DOMParser().parseFromString(text, 'text/html')

      // Get both script tags
      const settingsScript = doc.querySelector(
        '#SubscriptionWidgetConfig__shopify_settings'
      )
      const configsScript = doc.querySelector(
        '#SubscriptionWidgetConfig__configs'
      )

      console.log('Found settings script:', settingsScript)
      console.log('Found configs script:', configsScript)

      if (!settingsScript) throw new Error('No Recharge settings found')
      if (!configsScript) throw new Error('No Recharge configs found')

      // Extract the entire SubscriptionWidgetConfig object
      const extractConfig = function (scriptContents) {
        // Create a mock window object
        const mockWindow = { SubscriptionWidgetConfig: {} }

        // Execute all script contents in the context of our mock window
        scriptContents.forEach((content) => {
          new Function('window', content)(mockWindow)
        })

        // Return the complete config
        return mockWindow.SubscriptionWidgetConfig
      }

      // Get the full configuration by combining both scripts
      const subscriptionConfig = extractConfig([
        settingsScript.textContent,
        configsScript.textContent,
      ])

      console.log('Full subscription config:', subscriptionConfig)

      // Access all parts of the config
      const shopConfig = subscriptionConfig.shop
      const formattedPrices = subscriptionConfig.formattedPrices
      const configs = subscriptionConfig.configs

      console.log('Shop config:', shopConfig)
      console.log('Formatted prices:', formattedPrices)
      console.log('Configs:', configs)

      const variantPlans = formattedPrices[this.variantId]?.sellingPlans

      if (!variantPlans || !Object.keys(variantPlans).length) {
        throw new Error('No selling plans found for this variant')
      }

      const firstPlanId = Object.keys(variantPlans)[0]
      console.log('Sending to cart:', {
        id: parseInt(this.variantId),
        selling_plan: parseInt(firstPlanId),
        quantity: 1,
      })
      // const response = await fetch('/cart/add.js', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({
      //     items: [
      //       {
      //         id: parseInt(this.variantId),
      //         quantity: 1,
      //         selling_plan: parseInt(firstPlanId),
      //       },
      //     ],
      //   }),
      // })

      if (!response.ok) throw new Error('Cart add failed')
      alert('Subscription added to cart!')
    } catch (err) {
      console.error('Subscription add failed:', err)
      alert('Error adding subscription to cart')
    }
  }
}

customElements.define('product-card-subscription', ProductCardSubscription)
